import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import { siteInfo } from '@/mocks/site';

export default function AboutPage() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于我们｜深夜爆料',
      description:
        '深夜爆料是一档以第一手爆料与新瓜速递为核心的中文资讯站点，坚持双重交叉核实与线索人保护。',
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '深夜爆料',
      email: siteInfo.email,
      foundingDate: siteInfo.since,
      description: siteInfo.description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: '/about' },
      ],
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="关于我们｜深夜爆料 品牌介绍与内容原则"
        description="了解深夜爆料的品牌定位、发展理念与内容原则：以第一手爆料为核心，坚持双重交叉核实、线索人保护与及时更正，为 42 万深夜读者提供可信的新瓜速递。"
        keywords="深夜爆料,关于深夜爆料,深夜爆料内容原则,深夜爆料首发,新瓜速递"
        path="/about"
        ogType="website"
        jsonLd={jsonLd}
      />

      <div className="mx-auto w-full px-4 py-8 md:px-10 md:py-12">
        <Breadcrumbs items={[{ label: '关于我们' }]} />

        <header className="grid grid-cols-1 gap-8 lg:grid-cols-[1.5fr_1fr] lg:items-center">
          <div>
            <span className="text-xs tracking-[0.24em] text-primary-400">ABOUT US</span>
            <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-50 md:text-5xl">
              我们只想把「第一手」
              <br />
              这两个字做实
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
              深夜爆料从 {siteInfo.since} 年开始做一件事：在热点还没变成热搜之前，把已经可以被核实的那部分信息先讲出来。我们不生产情绪，只负责把线索查清楚、把时间线排明白，让你在五分钟内抓住重点。
            </p>
          </div>
          <dl className="grid grid-cols-2 gap-4">
            {siteInfo.stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg border border-background-200 bg-background-100 p-4"
              >
                <dt className="text-xs text-foreground-500">{item.label}</dt>
                <dd className="mt-2 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
                  {item.value}
                  <span className="ml-1 text-xs font-normal text-foreground-500">{item.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </header>

        <section className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <article className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
              <i className="ri-focus-3-line text-xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-lg font-bold text-foreground-50">网站定位</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              一个以爆料为核心的资讯站点，而不是综合门户。我们只做自己有能力核实的内容，覆盖娱乐、商界、科技、社会与从业者自述五个方向。
            </p>
          </article>
          <article className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
              <i className="ri-heart-3-line text-xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-lg font-bold text-foreground-50">目标读者</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              为那些在深夜还醒着、想知道「到底发生了什么」的人写作。不假设读者已经了解背景，重要的事一定从起因讲起。
            </p>
          </article>
          <article className="rounded-lg border border-background-200 bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500/15 text-secondary-300">
              <i className="ri-line-chart-line text-xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-lg font-bold text-foreground-50">发展理念</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              速度重要，但不是唯一的标准。我们宁可晚半小时，也不愿意让一条没核实过的信息出现在首页。
            </p>
          </article>
        </section>

        <section className="mt-16">
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            内容原则：四条不会让步的底线
          </h2>
          <p className="mt-3 max-w-2xl text-sm text-foreground-500">
            这四条写在编辑手册第一页，适用于每一条爆料，无论热度多高。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {siteInfo.principles.map((item) => (
              <article
                key={item.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-500/40"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-background-200 text-primary-400">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-100">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-16 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            一路走来的几个节点
          </h2>
          <ol className="mt-8 relative ml-1.5 border-l border-background-300/60 pl-6">
            {siteInfo.milestones.map((item) => (
              <li key={item.year} className="relative pb-8 last:pb-0">
                <span className="absolute -left-[31px] top-1 flex h-3.5 w-3.5 rounded-full border-2 border-background-100 bg-accent-500"></span>
                <span className="font-heading text-lg font-bold text-accent-400">{item.year}</span>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-400">
                  {item.text}
                </p>
              </li>
            ))}
          </ol>
        </section>

        <section className="mt-16">
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            读者怎么说
          </h2>
          <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-3">
            {siteInfo.testimonials.map((item) => (
              <figure
                key={item.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <blockquote className="flex-1 text-sm leading-relaxed text-foreground-300">
                  {item.content}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/80 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/15 font-heading text-base font-bold text-primary-300">
                    {item.initial}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-100">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        <section className="mt-16 flex flex-col items-start justify-between gap-6 rounded-lg border border-primary-500/25 bg-gradient-to-br from-background-100 to-primary-950/40 p-7 md:flex-row md:items-center md:p-10">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
              想聊线索、合作，或者只是提个意见？
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              编辑在线时段为 {siteInfo.contactHours}，常态邮箱 {siteInfo.email}。
            </p>
          </div>
          <Link
            to="/contact"
            className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
          >
            <i className="ri-mail-send-line"></i>
            前往联系我们
          </Link>
        </section>
      </div>
    </SiteLayout>
  );
}